export var TrackingUserTypeEnum;
(function (TrackingUserTypeEnum) {
    TrackingUserTypeEnum["CLIENT"] = "client";
    TrackingUserTypeEnum["PROSPECT"] = "prospect";
})(TrackingUserTypeEnum || (TrackingUserTypeEnum = {}));
//# sourceMappingURL=tracking-user-type.enum.js.map